import { DefinitionDescription, DefinitionTerm } from "@/components/ui/definition-list.tsx";
import DimmingTypeDetails from "@/features/sub-families/components/summary/dimming-type-details.tsx";
import PowerSupplyDetails from "@/features/sub-families/components/summary/power-supply-details.tsx";
import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";
import { formatFilterLabel } from "@/features/sub-families/utils/formatters.ts";

export default function LightDetails() {
    const currentProduct = useCurrentProduct();

    if (!currentProduct) return null;

    const ledSource = currentProduct.properties.led_technics_light_source;
    const ledLuminaire = currentProduct.properties.led_technics_luminaire;

    return (
        <>
            <PowerSupplyDetails />
            <DimmingTypeDetails />
            <DefinitionTerm>{ledSource.name}</DefinitionTerm>
            <DefinitionDescription>{formatFilterLabel(ledSource)}</DefinitionDescription>
            <DefinitionTerm>{ledLuminaire.name}</DefinitionTerm>
            <DefinitionDescription>{formatFilterLabel(ledLuminaire)}</DefinitionDescription>
        </>
    );
}
